import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import { labelIdent } from "assets/jss/BeaktShared/form.js";

const styles = {
    labelIdent: {
      ...labelIdent
    },  
    cardIconTitle: {
      ...cardTitle,
      marginTop: "15px",
      marginBottom: "0px"
    },  
  };
  
export default styles;